import { useShortcut } from "admin/lib/useShortcut";
import { useShortcutPathMap } from "./useShortcutPathMap";

export function useShortcutState() {
  const { data } = useShortcut();
  const { getState } = useShortcutPathMap();

  const { state: remote = {} } = data?.state ?? {};
  const { state: local = {} } = getState() ?? {};

  const state = { state: { ...remote, ...local } };

  return state;
}
